//@flow
import React from 'react'
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
// $FlowFixMe - JSON import
import Package from '../../../package.json'

const useStyles = makeStyles((theme) => ({
  footer: {
    background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
    borderTop: '1px solid rgba(0,0,0,0.06)',
    padding: theme.spacing(6, 0),
    marginTop: 'auto',
    width: '100%',
    position: 'relative',
    zIndex: 10,
  },
  gridContainer: {
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  heading: {
    fontWeight: 700,
    fontSize: '0.875rem',
    color: '#1e293b',
    marginBottom: theme.spacing(2),
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
  },
  link: {
    display: 'block',
    color: '#64748b',
    fontSize: '0.875rem',
    marginBottom: theme.spacing(1.5),
    textDecoration: 'none',
    transition: 'all 0.2s ease',
    '&:hover': {
      color: '#D4AF37',
      textDecoration: 'none',
      transform: 'translateX(4px)',
    },
  },
  copyright: {
    color: '#94a3b8',
    fontSize: '0.75rem',
    marginTop: theme.spacing(4),
    paddingTop: theme.spacing(3),
    borderTop: '1px solid rgba(0,0,0,0.06)',
  },
  version: {
    color: '#cbd5e1',
    fontSize: '0.75rem',
    fontWeight: 500,
  },
  brandName: {
    fontWeight: 800,
    fontSize: '1.25rem',
    background: 'linear-gradient(135deg, #D4AF37 0%, #AA8C2C 100%)',
    '-webkit-background-clip': 'text',
    '-webkit-text-fill-color': 'transparent',
    marginBottom: theme.spacing(1),
    display: 'inline-block',
  }
}));

function AppFooter(): React$Node {
    const classes = useStyles();
    const currentYear = new Date().getFullYear();
  
    return (
      <footer className={classes.footer}>
        <Container maxWidth="lg">
          <Grid container spacing={4} className={classes.gridContainer}>
            <Grid item xs={12} md={4}>
              <Typography className={classes.brandName}>
                PHOENIX
              </Typography>
              <Typography variant="body2" style={{ color: '#64748b', maxWidth: 300, lineHeight: 1.6 }}>
                Advanced data management and crowd workforce orchestration platform.
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6} md={4}>
              <Typography className={classes.heading}>
                Legal
              </Typography>
              <Link href="https://gigsdata.com/privacy" className={classes.link}>
                Privacy Policy
              </Link>
              <Link href="https://gigsdata.com/termOfService" className={classes.link}>
                Terms of Service
              </Link>
            </Grid>
            
            <Grid item xs={12} sm={6} md={4}>
              <Typography className={classes.heading}>
                Contact
              </Typography>
              <Link href="https://gigsdata.com" className={classes.link}>
                Contact Support
              </Link>
              <Typography variant="body2" style={{ color: '#64748b', marginTop: 8 }}>
                Operating Partner: Dataswarm LLC
              </Typography>
            </Grid>
          </Grid>

          <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" className={classes.copyright}>
            <Typography variant="caption" color="textSecondary">
              © {currentYear} LESOFI LLP. All rights reserved.
            </Typography>
            <Typography className={classes.version}>
              v{Package.version}
            </Typography>
          </Box>
        </Container>
      </footer>
    );
}

export default (React.memo<{||}>(AppFooter): React$AbstractComponent<{||}, mixed>)